module.exports = __webpack_public_path__ + "officialStatic/img/dzxszDetailList1.ad0e6d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/dzxszDetailList1.png
// module id = kp1N
// module chunks = 0